import { create } from "zustand";

import type { UpdateUserSettingsPayload, UserProfile, UserSettings } from "@/api/user";

interface UserState {
  profile: UserProfile | null;
  settings: UserSettings | null;
  setProfile: (profile: UserProfile) => void;
  setSettings: (settings: UserSettings) => void;
  updateSettings: (partial: UpdateUserSettingsPayload) => void;
  reset: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  profile: null,
  settings: null,
  setProfile: (profile) => set({ profile }),
  setSettings: (settings) => set({ settings }),
  updateSettings: (partial) =>
    set((state) =>
      state.settings
        ? { settings: { ...state.settings, ...partial } }
        : state
    ),
  reset: () => set({ profile: null, settings: null })
}));
